import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class HttpService {

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };



  constructor(private http: HttpClient) { }

  public get(url: string, options?: any): Observable<any> {
    return this.http.get(url);
  }

  public post(url: string, body: any, options?: any): Observable<any> {
    return this.http.post<any>(url, body, options).pipe(retry(1));

  }

  public put(url: string, body: any, options?: any): Observable<any> {
    return this.http.get<any>(url).pipe(retry(1));
  }

  public delete(url: string, options?: any): Observable<any> {
    return this.http.get<any>(url).pipe(retry(1));
    // return this.http.get<any>(url).pipe(retry(1), catchError(this.handleError));
  }

  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }


}